import BaseWidget from "common/widgets/base/BaseWidget";
import locale from "common/managers/locale";

/**
 * This widget is a LoadingBar that will attach itself to its parent element.
 * It is better than the preloader binding and CSSPreloader widget because it is accessible.
 * @type {kendo.ui.Widget}
 */
const LoadingBar = BaseWidget(kendo.ui.Widget).extend({

    options: {
        name: "LoadingBar",

        // whether the children are fully hidden or not
        keepContent: false,

        // selector to use to find a parent element, if not the immediate parent
        parentEl: false
    },

    _value: false,

    init: function() {
        kendo.ui.Widget.fn.init.apply(this, arguments);
        if (!this.element.attr("id")) {
            throw "LoadingBar widget must have an id";
        }
        this.element
            .append($("<div>").addClass("square1 displayWhileLoading"))
            .append($("<div>").addClass("square2 displayWhileLoading"))
            .append($("<div>").addClass("square3 displayWhileLoading"));

        this.element.addClass("displayWhileLoading loadingBar");

        this.parent = this.options.parentEl ? this.element.closest(this.options.parentEl) : this.element.parent();
        // append the id to the existing value of aria-describedby
        var id = this.element.attr("id");
        this.parent.attr("aria-describedby", function(index, oldValue) {
            return ((oldValue ? oldValue.replace(id, "") + " " : "") + id).split(" ").filter(function(item) {
                return !!item;
            }).join(" ");
        });
        this.parent.addClass("loading-bar-parent");

        //aria props
        this.element.attr("role", "progressbar");
        this.element.attr("aria-valuemin", "0");
        this.element.attr("aria-valuemax", "100");

        this.value(false);
    },

    /**
     * Update display.
     * @private
     */
    _update: function() {
        var value, text;
        if (this._value) {
            value = "50";
            text = locale.get("content.loading");
        } else {
            value = "100";
            text = locale.get("content.loaded");
        }
        this.element.toggleClass("loading", this._value);
        this.parent.toggleClass("loading", this._value);
        this.parent.toggleClass("keepContent", this._value && this.options.keepContent);
        this.element
            .attr("aria-valuenow", value)
            .attr("aria-valuetext", text);
    },

    /**
     * Setting the loading state.  True when loading.
     */
    value: function(val) {
        if (val !== undefined) {
            val = !!val;
            this._value = !!val;
            this._update();
        } else {
            return this._value;
        }
    },

    /**
     * Set focus to the loading bar
     */
    focus: function() {
        this.getARIAElements().focus();
    }
});
kendo.ui.plugin(LoadingBar);
export default LoadingBar;
